export enum COUNTRIES {
    US = 'US',
    CA = 'CA',
}

export enum RESTRICTED_COUNTRIES {
    CU = 'CU',
    IR = 'IR',
    KP = 'KP',
    SD = 'SD',
    SY = 'SY',
}

type TaxCountries = {
    [key: string]: string
}

export const TAX_COUNTRIES: TaxCountries = {
    CH: 'CHE',
    GR: 'EL',
}

// List of EU contries and sample implementation can be found at following link
// https://confluence.ops.expertcity.com/spaces/MW/pages/831588245/all+-+TrustArc+implied+cookie+consent+and+country+codes
export const EU_COUNTRIES = new Set([
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
])
